import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import {OauthService} from './oauth.service';
import {App} from 'ionic-angular';
import {Http} from '@angular/http';
import {ToolsService} from './tools.service';
import { Subject } from 'rxjs/Subject';
import {AppProvider} from "../../core/app/app-provider.service";
import {SessionStorageService} from '../../shared/services/sessionStorage.service';
import {Observable} from "rxjs/Observable";

@Injectable()
export class MenuService extends OauthService {

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
    protected sessionStorage: SessionStorageService,
  ) {
    super(http, app, appProvider, tools);
  }

  public init(): Observable<any> {
    const url = this.Routing.generate('api_get_menu', {'_format': 'json'}, true);

    return this.http
      .get(`${url}`, {headers: this.updateHeaders()})
      .map(response => response.json().data);
  }

  public saveSession(menu: any) {
    this.sessionStorage.setDateMenu(new Date());
    this.sessionStorage.setMenu(menu);
  }

  public removeSession() {
    this.sessionStorage.removeDateMenu();
    this.sessionStorage.removeMenu();
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/menu.service.ts